import { render, staticRenderFns } from "./top.vue?vue&type=template&id=9b27e376&scoped=true&"
import script from "./top.vue?vue&type=script&lang=js&"
export * from "./top.vue?vue&type=script&lang=js&"
import style0 from "./top.vue?vue&type=style&index=0&id=9b27e376&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b27e376",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgIcon: require('/app/components/svgIcon/svgIcon.vue').default,ALink: require('/app/components/aLink.vue').default})
